import { action, Action } from 'easy-peasy';

export interface VersionModel {
  apiVersion: number;
  setApiVersion: Action<VersionModel, number>;
}

export const versionModel: VersionModel = {
  apiVersion: 1,
  setApiVersion: action((state, version) => {
    state.apiVersion = version;
  }),
};
